export class SlideshowConfig {
  ratio = '';
  transition = 'pull';
  velocity = 1;
  autoplay = false;
  pauseAutoplay = false;
  interval = 7;
  kenBurns = '';
  kenBurnsDuration = 15;

  static normalize(styles: Partial<SlideshowConfig>): SlideshowConfig {
    const pureStyles = new SlideshowConfig();

    pureStyles.ratio = styles.ratio ?? pureStyles.ratio;
    pureStyles.transition = styles.transition ?? pureStyles.transition;
    pureStyles.velocity = styles.velocity ?? pureStyles.velocity;
    pureStyles.autoplay = styles.autoplay ?? pureStyles.autoplay;
    pureStyles.pauseAutoplay = styles.pauseAutoplay ?? pureStyles.pauseAutoplay;
    pureStyles.interval = styles.interval ?? pureStyles.interval;
    pureStyles.kenBurns = styles.kenBurns ?? pureStyles.kenBurns;
    pureStyles.kenBurnsDuration = styles.kenBurnsDuration ?? pureStyles.kenBurnsDuration;

    return pureStyles;
  }
}
